const keys = ['adminTab', 'workspace', 'classId', 'course', 'classDate', 'trainer', 'classView'];

export function readDashboardView(search, allowedTabs, courseTabs) {
  const params = new URLSearchParams(search);
  const currentTab = allowedTabs.includes(params.get('adminTab')) ? params.get('adminTab') : 'Dashboard';
  const courseWorkspace = params.get('workspace') === 'classes' ? 'classes' : 'courses';
  const isClassView = courseTabs.includes(currentTab);
  const selectedClassId = isClassView ? (params.get('classId') || '') : '';
  const course = params.get('course');
  const date = params.get('classDate') || '';
  return {
    currentTab,
    courseWorkspace,
    selectedClassId,
    classCourseFilter: course === '__all__' || courseTabs.includes(course) ? course : '',
    classDateFilter: /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : '',
    trainerId: params.get('trainer') || '',
    showClassResults: !selectedClassId || params.get('classView') !== 'pipeline',
  };
}

export function dashboardViewUrl(href, view) {
  const url = new URL(href);
  keys.forEach(key => url.searchParams.delete(key));
  const values = {
    adminTab: view.currentTab === 'Dashboard' ? '' : view.currentTab,
    workspace: view.courseWorkspace === 'classes' ? 'classes' : '',
    classId: view.selectedClassId,
    course: view.classCourseFilter,
    classDate: view.classDateFilter,
    trainer: view.trainerId,
    classView: view.selectedClassId && !view.showClassResults ? 'pipeline' : '',
  };
  Object.entries(values).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });
  return `${url.pathname}${url.search}${url.hash}`;
}
